import { Theme_Mode_Dark, Theme_Mode_Light, type Theme_Mode } from "@/lib/theme/types";

export function Theme_Parse(Value: unknown): Theme_Mode | null {
  if (Value === Theme_Mode_Light || Value === Theme_Mode_Dark) {
    return Value;
  }
  return null;
}
